import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 168px;
  display: flex;
  align-items: center;
  overflow: hidden;
  margin-top: 20px;
  border-radius: 32px;
  border: 1px solid ${({ $colors }) => $colors};

  .bord {
    display: block;
    width: 24px;
    align-self: stretch;
    /* min-height: 160px; */
    background-color: ${({ $colors }) => $colors};
  }

  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;

    .bord {
      width: 100%;
      min-height: 1px;
    }
  }
`;

export const GroupImg = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 8px 20px;
  padding-right: 60px;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }

  img {
    width: 100%;
    width: 64px;
    height: 64px;
    object-fit: cover;
    border-radius: 100%;
  }

  span {
    margin-top: 12px;
  }

  &::before {
    content: '';
    position: absolute;
    width: 3px;
    height: 80%;

    background-color: rgba(206, 206, 206, 0.25);

    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding: 12px 8px;
    gap: 20px;

    img {
      max-width: 60px;
    }

    span {
      margin: 4px;
    }
  }
`;

export const GroupText = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 40px;
  padding: 16px 0;

  h3 {
    width: 100%;
    display: flex;
    align-items: flex-end;

    img {
      position: relative;
      top: -6px;
      width: 100%;
      max-width: 24px;
      margin-left: 8px;
    }
  }

  p {
    margin-top: 8px;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
    margin-left: 0;
    padding: 12px 8px;
  }
`;

export const GroupButtons = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  margin-top: 24px;

  button {
    padding: 12px 32px;
    border-radius: 32px;
    border: 1px solid;
    color: ${({ theme }) => theme.colors.grey.white};

    &:hover {
      opacity: 0.7;
      transition: 0.7s;
    }
  }

  .green {
    background-color: rgba(71, 217, 4, 0.24);
    border-color: ${({ theme }) => theme.colors.outher.success};
  }

  .red {
    background-color: rgba(255, 0, 4, 0.24);
    border-color: ${({ theme }) => theme.colors.outher.danger};
  }
`;
